import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { WhatsAppButton } from "@/components/CTAButtons";

export default function NotFound() {
  return (
    <>
      <SEO title="Página não encontrada | Auto Socorro Pimenta" description="Página não encontrada." path="/404" />
      <section className="flex min-h-[80svh] items-center justify-center px-5 pt-28 text-center">
        <div>
          <p className="font-display text-[24vw] leading-none text-brand-red md:text-[12rem]">404</p>
          <h1 className="mt-4 font-heading text-2xl font-semibold uppercase tracking-wide text-white">Página não encontrada</h1>
          <p className="mx-auto mt-4 max-w-md text-white/60">A página que você procura não existe. Volte ao início ou fale com a nossa equipe.</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/" data-testid="notfound-home" className="rounded-sm border border-white/30 px-8 py-4 font-heading font-semibold uppercase tracking-wide text-white transition-colors hover:bg-white hover:text-brand-obsidian">
              Voltar ao Início
            </Link>
            <WhatsAppButton testid="notfound-whatsapp" />
          </div>
        </div>
      </section>
    </>
  );
}
